import { createBrowserHistory } from "history";
import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware from "redux-thunk";
import createRootReducer from "./reducers";
import { spinnerMiddleware } from "./middleware";

const history = createBrowserHistory();

const reducer = createRootReducer(history);

const store = createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(
      routerMiddleware(history),
      thunkMiddleware,
      spinnerMiddleware
    )
  )
);

export { store, history };
